import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-digital';
export var ID = 'icon-digital';
/* eslint-disable max-len */

export var SVGDigital = function SVGDigital() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 58 69"
  }, React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M25.277 34.5h3.65l-1.825-5.517"
  }), React.createElement("path", {
    d: "M52.778 0H18.544c-.066 0-.12.03-.183.037-.062.01-.12.02-.18.038-.244.066-.472.172-.646.348L.42 17.67c-.175.175-.28.402-.346.65-.017.063-.028.12-.037.183-.008.064-.037.118-.037.184v43.126c0 .793.64 1.437 1.426 1.437h33.037c.41 0 .802-.18 1.073-.492.815-.937 1.977-1.636 3.36-2.024.616-.172 1.044-.74 1.044-1.383v-12.4l13.184-3.322c.636-.164 1.08-.74 1.08-1.4V1.438C54.205.643 53.567 0 52.78 0zm-35.66 4.908v10.905c0 .793-.64 1.437-1.427 1.437H4.87L17.117 4.908zm-.02 37.015c-.112.67-.674 1.173-1.35 1.202h-.057c-.652 0-1.226-.446-1.383-1.09l-1.47-5.92-1.468 5.923c-.167.662-.857 1.113-1.442 1.09-.676-.03-1.24-.532-1.352-1.202l-2.853-17.25c-.128-.785.4-1.526 1.175-1.656.76-.135 1.51.397 1.64 1.182l1.724 10.433 1.19-4.795c.316-1.28 2.45-1.28 2.77 0l1.19 4.795 1.722-10.433c.132-.785.885-1.317 1.64-1.182.78.13 1.307.87 1.176 1.653l-2.853 17.25zm16.16 1.13c-.15.05-.3.072-.45.072-.596 0-1.152-.382-1.355-.983l-1.575-4.767h-5.55l-1.58 4.767c-.25.753-1.058 1.16-1.805.908-.747-.253-1.15-1.066-.9-1.82l5.704-17.25c.39-1.173 2.32-1.173 2.708 0l5.705 17.25c.25.757-.154 1.57-.9 1.823zm15.17-18.16l-5.706 17.25c-.197.585-.742.982-1.355.982-.614 0-1.158-.397-1.355-.983l-5.706-17.25c-.248-.753.157-1.567.9-1.82.752-.247 1.556.158 1.807.908l4.35 13.16 4.352-13.16c.254-.753 1.064-1.152 1.805-.908.75.253 1.156 1.067.908 1.82z"
  }), React.createElement("path", {
    d: "M56.51 46.302c-.348-.273-.8-.368-1.224-.262l-11.41 2.875c-.638.16-1.083.74-1.083 1.398v13.095c-.442-.095-.916-.158-1.426-.158-2.48 0-4.28 1.21-4.28 2.875S38.887 69 41.367 69c2.48 0 4.28-1.21 4.28-2.875V51.437l8.558-2.157v11.256c-.442-.098-.916-.16-1.427-.16-2.48 0-4.28 1.21-4.28 2.874 0 1.665 1.8 2.875 4.28 2.875 2.48 0 4.28-1.21 4.28-2.875V47.437c0-.442-.203-.862-.548-1.135z"
  })));
};
/* eslint-disable max-len */

var Digital = function Digital(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGDigital
  });
};

Digital.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Digital;